<template>
  <div>
    <header class="modal-header">
      <h3 class="modal-title">User Profiles</h3>
    </header>
    <div class="modal-body">
      <ProfileAvatar @avatarUploaded="updateUserPic" :pic-url="userProfile.PIC_URL" v-if="caller === 'header'" />
      <b-form class="mt-2">
        <b-form-group
          v-show="caller !== 'header'"
          label="USERNAME:"
          label-for="username">
          <b-form-input
            id="username"
            type="text"
            v-model="model.USER_NAME"
            disabled>
          </b-form-input>
        </b-form-group>
        <b-row>
          <b-col md="6">
            <b-form-group
              label="FIRST NAME:"
              label-for="firstName">
              <b-form-input
                id="firstName"
                type="text"
                v-model="userProfile.FIRST_NAME"
                required>
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="LAST NAME:"
              label-for="lastName">
              <b-form-input
                id="lastName"
                type="text"
                v-model="userProfile.LAST_NAME"
                required>
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              label="PHONE:"
              label-for="phone">
              <b-form-input
                id="phone"
                type="text"
                v-model="userProfile.CONTACT_PHONE"
                required>
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label="FAX:"
              label-for="fax">
              <b-form-input
                id="fax"
                type="text"
                v-model="userProfile.CONTACT_FAX"
                required>
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group
          v-if="caller !== 'header'"
          label="STATUS:"
          label-for="status">
          <c-switch
            color="success"
            variant="pill"
            size="lg"
            v-model="userProfile.STATUS" />
        </b-form-group>
      </b-form>
    </div>
    <footer class="modal-footer">
      <b-btn :size="'sm'" @click="$emit('close')">Cancel</b-btn>
      <b-btn :variant="'primary'" :size="'sm'" @click="handleSubmit" :disabled="isFetching">Update</b-btn>
    </footer>
  </div>
</template>
<script>
import { Switch as cSwitch } from '@coreui/vue'
import { auth, server } from '@/services/'
import { ProfileAvatar } from '@/components/'

export default {
  name: 'user-profiles-modal',
  props: {
    mode: String,
    caller: String,
    model: Object
  },
  data () {
    return {
      userProfile: Object,
      isFetching: false,
      avatarOptions: {
        url: `${process.env.VUE_APP_API_URL}/fileUpload/Pic_User`,
        headers: {'authorization': auth.getToken()}
      }
    }
  },
  components: {
    cSwitch,
    ProfileAvatar
  },
  methods: {
    updateUserPic(picUrl) {
      this.userProfile.PIC_URL = picUrl
      let POST_URL = 'updateUP_byUACode/jwtCode'
      let reqBody = [{
        firstName: this.userProfile.FIRST_NAME,
        lastName: this.userProfile.LAST_NAME,
        contactPhone: this.userProfile.CONTACT_PHONE || '',
        contactFax: this.userProfile.CONTACT_FAX || '',
        picUrl: this.userProfile.PIC_URL
      }]
      let payload = {
        apiUrl: POST_URL,
        reqBody: reqBody
      }

      this.$store.dispatch('userProfile/updateProfile', payload).then(
        resp => {
          this.setProfile(payload.reqBody)
          this.$store.commit('userProfile/setUser', user)
        },
        err => {

        }
      )
    },
    handleSubmit (e) {
      e.preventDefault()
      this.isFetching = true
      let POST_URL = ''
      let reqBody = [{
        firstName: this.userProfile.FIRST_NAME,
        lastName: this.userProfile.LAST_NAME,
        contactPhone: this.userProfile.CONTACT_PHONE || '',
        contactFax: this.userProfile.CONTACT_FAX || '',
        picUrl: this.userProfile.PIC_URL
      }]
      if (this.caller === 'header') {
        POST_URL = 'updateUP_byUACode/jwtCode'
      } else {
        POST_URL = `/updateUP_byUACode/${this.userProfile.USER_ACCOUNT_CODE}`
      }
      let payload = {
        apiUrl: POST_URL,
        reqBody: reqBody
      }
      this.$store.dispatch('userProfile/updateProfile', payload).then(
        resp => {
          this.setProfile(payload.reqBody)
          this.isFetching = false
          this.$emit('close')
        },
        err => {
          this.isFetching = false
          this.$emit('close')
        }
      )
    },
    setProfile (reqBody) {
      // update user on localStorage
      let user = auth.getUser()
      user.USER_PROFILE_FIRST_NAME = reqBody[0].firstName
      user.USER_PROFILE_LAST_NAME = reqBody[0].lastName
      user.USER_PROFILE_PIC_URL = reqBody[0].picUrl
      auth.setUser(user)
      this.$store.commit('userProfile/setUser', user)
    },
    getProfile () {
      server.get(`/getUP_byUACode/${this.model.CODE}`).then(
        resp => {
          this.userProfile = resp.data.msgContent.data[0]
          this.userProfile.STATUS ? this.userProfile.STATUS = true : this.userProfile.STATUS = false
        }
      )
    }
  },
  created () {
    if (this.caller === 'userAccount') {
      this.getProfile()
    } else {
      this.userProfile = {...this.model}
    }
  }
}
</script>
